import { Button, Card, Col, Divider, Flex, Form, Row } from 'antd';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

// components
import BackButton from 'components/backButton/backButton';
import ComponentHeader from 'components/componentHeader/componentHeader';
import FormElement from 'components/formElement/formElement';
import PhoneInputComponent, { PhoneInputReturn } from 'components/phoneInput/phoneInput';
import SwitchElement from 'components/switch/switch';
import PageTitle from 'components/title/title';

// services
import { checkPhoneValidation } from 'utils/validators/phone';

type switchFieldName = 'company_information' | 'mortgage_request' | 'mortgage_release';

const BusinessUsersManagementUpdatePage: FunctionComponent = () => {
	const { t } = useTranslation();
	const [userForm] = Form.useForm();

	type fieldType = {
		password: string;
		confirmPassword: string;
	};

	const onChangePhone = ({ dialCode, number }: PhoneInputReturn) => {
		userForm.setFieldsValue({
			phone: dialCode + number,
		});
	};

	const validatePhone = (_: any, value: string) => {
		// if (checkPhoneValidation(value)) {
		// 	return Promise.resolve();
		// } else if (value) return Promise.reject(new Error(t('COMMON.PHONE_INVALID')));
		// else return Promise.reject();
	};

	const validatePassword = (_: any, value: string) => {
		if (!value || userForm.getFieldValue('password') === value) {
			return Promise.resolve();
		}
		return Promise.reject(new Error(t('COMMON.PASSWORDS_NOT_MATCH')));
	};

	const onSwitchChange = (fieldName: switchFieldName, value: boolean) => {
		userForm.setFieldValue(fieldName, value);
	};

	return (
		<>
			<PageTitle name={t('TITLE.USERS_MANAGEMENT')} />

			<BackButton />

			<Card>
				<ComponentHeader title={t('USERS_MANAGEMENT.UPDATE_USER')} />

				<Form form={userForm}>
					<Row gutter={[16, 16]}>
						<Col span={24} md={12}>
							<FormElement label={t('COMMON.NAME')} name="name" type="text" />
						</Col>

						<Col span={24} md={12}>
							<FormElement label={t('COMMON.EMAIL')} name="email" type="email" />
						</Col>

						<Col span={24} md={12}>
							<PhoneInputComponent fullWidth={false} />
						</Col>
					</Row>
				</Form>

				<Divider />

				<ComponentHeader title={t('USERS_MANAGEMENT.ACCESS_ROLE')} subtitle={t('USERS_MANAGEMENT.SELECT_ACCESS_AUTHORITY')} />

				<Row gutter={[16, 16]}>
					<Col span={24} md={12} lg={8}>
						<SwitchElement
							label={t('USERS_MANAGEMENT.COMPANY_INFORMATION')}
							onChange={(value) => onSwitchChange('company_information', value)}
						/>
					</Col>
					<Col span={24} md={12} lg={8}>
						<SwitchElement label={t('USERS_MANAGEMENT.MORTGAGE_REQUEST')} onChange={(value) => onSwitchChange('mortgage_request', value)} />
					</Col>
					<Col span={24} md={12} lg={8}>
						<SwitchElement label={t('USERS_MANAGEMENT.MORTGAGE_RELEASE')} onChange={(value) => onSwitchChange('mortgage_release', value)} />
					</Col>

					<Col span={24}>
						<Flex justify="flex-end">
							<Form.Item style={{ marginTop: 40 }}>
								<Button type="primary" className="mt-4 px-3 py-2" htmlType="submit">
									{t('COMMON.CREATE')}
								</Button>
							</Form.Item>
						</Flex>
					</Col>
				</Row>
			</Card>
		</>
	);
};

export default BusinessUsersManagementUpdatePage;
